import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import TableComponent from "../../TableComponent/TableComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import {
  completeManualCheck,
  fetchMergedBrandProcessDetails,
  fetchPaginateMergedBrandProcessDetails,
  resetMergeRequestProcessLogTable,
} from "../../../redux/LivePlatform/LivePlatformAction";
import BackBtn from "../../Template/BackBtn";
import MergeRequestBrandProcessLogTableColumn from "./MergeRequestBrandProcessLogTableColumn";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button } from "antd";

function MergeRequestBrandProcessLogPage(props: any) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const urlDivided = location.pathname.split("/");
  const brandName = location.state.record ? location.state.record.name : "";
   const brandStatus = location.state.record ? location.state.record.status : "";
   
  const mergedBrandProcessLogState = useSelector(
    (state: RootState) =>
      state.livePlatformState.duplicateBrandState
        .mergedDuplicateBrandProcessLogDetails
  );

  const mergeRequestId = Number(urlDivided[urlDivided.length - 1]);
  const loading = useSelector(
    (state: RootState) =>
      state.livePlatformState.duplicateBrandState.manualCheckCompleteDetails
        .loading
  );
 
  
  useEffect(() => {
    if (mergeRequestId) {
      dispatch(fetchMergedBrandProcessDetails({ mergeRequestId }));
      return () => {
        dispatch(resetMergeRequestProcessLogTable());
      };
    }
  }, [mergeRequestId]);

  function handleTableSorting(sorter: any): void {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = {
      ...mergedBrandProcessLogState.currentRequestBody,
      mergeRequestId: mergeRequestId,
      SortColumn: sorter.field,
      isAsc: isAscend(sorter.order),
    };

    dispatch(resetMergeRequestProcessLogTable());
    dispatch(fetchMergedBrandProcessDetails(newSortingRequestBody));
  }

function backActionClick() {
  navigate(-1);
}

 async function onClickMarkAsVerified() {
  const result = await dispatch(
    completeManualCheck({ mergeRequestId: mergeRequestId, Status: brandStatus })
  );
  if (completeManualCheck.fulfilled.match(result)) {
    backActionClick();
  }
}

  return (
  
      <div className="body-container pt-3 h-100 gap-3">
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <BackBtn
              backActionClick={() => backActionClick()}
              backPath="/live/merge-brand"
            />
            <h3>Process Logs - {brandName}</h3>
          </div>
          {brandStatus==="RequireManualCheck"? <div>
            <span
              style={{ paddingRight: "15px", paddingLeft: "4px" }}
            >
              <Button
                type="default"
                className="action-btn"
                loading={loading}
                onClick={() => onClickMarkAsVerified()}
              >
                Mark as Verified
              </Button>
            </span>
          </div>:null}
         
        </div>
        {/* <MergeBrandDetailsComponent /> */}
        <TableComponent
          columns={MergeRequestBrandProcessLogTableColumn}
          dataSource={
            mergedBrandProcessLogState.mergedBrandProcessDetails || []
          }
          pagination={mergedBrandProcessLogState.pagination}
          handleTableSorting={handleTableSorting}
          loading={mergedBrandProcessLogState.loading}
          fetchPaginatedData={() => fetchPaginateMergedBrandProcessDetails({mergeRequestId})}
          tableKey="MergeRequestBrandProcessLogTable"
        />
      </div>
    
  );
}

export default MergeRequestBrandProcessLogPage;
